import { gql, TypedDocumentNode } from '@common/hooks';
import {
  PaginatedShiftGapsQueryCgResponse,
  PaginatedShiftGapsQueryVariables,
} from '@common/graphql/schema';

export const SHIFT_GAP_QUERY: TypedDocumentNode<
  PaginatedShiftGapsQueryCgResponse,
  PaginatedShiftGapsQueryVariables
> = gql`
  query PaginatedShiftGaps(
    $limit: Int!
    $offset: Int!
    $filters: ShiftGapFilterInput
    $orderField: ShiftGapOrderField
    $orderDirection: OrderDirection
  ) {
    paginatedShiftGaps(
      limit: $limit
      offset: $offset
      filters: $filters
      orderField: $orderField
      orderDirection: $orderDirection
    ) {
      shiftGaps {
        id
        startDatetime
        shiftDuration
        timeZone
        timeOfDay
        dayOfWeek
        organizationUnit {
          id
          name
          costCenter
        }
        role {
          id
          abbreviation
        }
      }
      totalCount
    }
  }
`;
